jQuery(document).ready(function() {
    // Initialize first collection-img div as active
    var initialCollectionHandle = jQuery('.collection-list li:first-child').data('collection-handle');
    jQuery('.collection-img-' + initialCollectionHandle).addClass('active');

    // On hover over the anchor tag with class 'font-haas-16'
    jQuery('.hover-set').hover(
        function() {
            // Remove 'active' class from all collection-img divs
            jQuery('.collection-img').removeClass('active');

            // Get the collection_handle from the anchor's parent li
            var collection_handle = jQuery(this).closest('li').data('collection-handle');
            
            // Add 'active' class to corresponding collection-img div
            jQuery('.collection-img-' + collection_handle).addClass('active');
        },
        function() {
            // No action needed on hover out, unless you want specific behavior
        }
    );
});
   
jQuery(document).ready(function() {
    // Click event handler for .desktop-menu .custom-menu ul li a.li-2
    jQuery('.desktop-menu .custom-menu ul li a.li-1').click(function(e) {
        e.preventDefault(); // Prevent default link behavior
        
        // Add class 'active' to .mega-menu
        jQuery('.mega-menu').addClass('active');
        jQuery('.desktop-menu').addClass('active');
        
    });

    // Click event handler for close button
    jQuery('.mega-menu .close-btn').click(function(e) {
        e.preventDefault(); // Prevent default link behavior
        
        // Remove class 'active' from .mega-menu to close it
        jQuery('.mega-menu').removeClass('active');
        jQuery('.desktop-menu').removeClass('active');
    });

  jQuery('.huzi-tab-links li:first-child').addClass('active');
  jQuery('.huzi-tab-links span').on('click', function(e) {
    var targetTab = jQuery(this).data('tab');
    jQuery('.huzi-tab-content .huzi-tab').hide();
    jQuery('.huzi-tab-content .' + targetTab).show();
    jQuery(this).parent('li').addClass('active').siblings().removeClass('active');
    e.preventDefault();
  });
});

 $(document).ready(function() {
  function updateSelectedVariants() {
    var selectedOptions = []; // Array to store selected options
    $(".nws-variant-selection input[type='radio']:checked").each(function() {
      selectedOptions.push($(this).val().toLowerCase()); // Push the selected option value to the array
    });
    var dd = selectedOptions.join(''); // Concatenate selected options
    var id = $('input[name="'+dd+'"]').val(); // Get the corresponding variant ID
    $('input.product-variant-id').val(id); 

    var selectedColor = selectedOptions[0] || ''; // Get the selected color
    $("#selected-color").text(selectedColor);

    console.log("Selected options:", selectedOptions);
    console.log("Selected variant ID:", id);
  }

  // Ensure the first two variants are selected and add a specific class on page load
  function initializeSelection() {
    var $colorVariants = $(".color-variants input[type='radio']");
    var $sizeVariants = $(".size-variants input[type='radio']");
    
    if ($colorVariants.length > 0) {
      $colorVariants.eq(0).prop('checked', true).closest('fieldset').addClass('selected-variant').find('label').addClass('selected-variant-label'); // Check and add class to the fieldset and label of the first color variant
    }

    if ($sizeVariants.length > 0) {
      $sizeVariants.eq(0).prop('checked', true).closest('fieldset').addClass('selected-variant').find('label').addClass('selected-variant-label'); // Check and add class to the fieldset and label of the first size variant
    }

    updateSelectedVariants();
  }

  // Bind updateSelectedVariants function to change event of radio buttons
  $(".nws-variant-selection input[type='radio']").change(function() {
    $(".nws-variant-selection fieldset").removeClass('selected-variant').find('label').removeClass('selected-variant-label'); // Remove class from all fieldsets and labels
    $(this).closest('fieldset').addClass('selected-variant').find('label').addClass('selected-variant-label'); // Add class to the fieldset and label of the selected radio
    updateSelectedVariants();
  });

  // Call initializeSelection initially to set initial variant selections
  initializeSelection(); 
});


// JavaScript to handle sorting when a new option is selected
$(document).ready(function() {
  $('input[name="sort_by"]').change(function() {
    var selectedValue = $(this).val();
    // You can add logic here to perform the sorting based on the selectedValue
    // For example, you can reload the page with a query parameter for sorting.
    // Replace 'your-sorting-parameter' with the actual parameter your theme uses.
    var url = window.location.href;
    url = updateQueryStringParameter(url, 'sort_by', selectedValue);
    window.location.href = url;
  });

  // Function to update query string parameter
  function updateQueryStringParameter(uri, key, value) {
    var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    var separator = uri.indexOf('?') !== -1 ? "&" : "?";
    if (uri.match(re)) {
      return uri.replace(re, '$1' + key + "=" + value + '$2');
    } else {
      return uri + separator + key + "=" + value;
    }
  }
});


jQuery('.nws-pdp-slider').slick({
    dots: false,
    arrows: true,
    infinite: false,
    slidesToShow: 1,
    autoplay: false,
    speed: 1000,
    autoplaySpeed: 3000,
    slidesToScroll: 1
});

jQuery('.nws-best-seller').slick({
    dots: false,
    arrows: true,
    infinite: false,
    slidesToShow: 4,
    autoplay: false,
    speed: 1000,
    autoplaySpeed: 3000,
    slidesToScroll: 1,
    responsive: [{
        breakpoint: 1320,
        settings: {
            arrows: false
        }
    }, 
    {
      breakpoint: 993,
      settings: {
          arrows: false,
          slidesToShow: 3,
          slidesToScroll: 1
      }
    }, 
    {
      breakpoint: 601,
      settings: {
          arrows: false,
          slidesToShow: 2,
          slidesToScroll: 1
      }
    }]
}); 

jQuery('.nws-best-seller-2').slick({
    dots: false,
    arrows: true,
    infinite: false,
    slidesToShow: 5,
    autoplay: false,
    speed: 1000,
    autoplaySpeed: 3000,
    slidesToScroll: 1,
    responsive: [{
        breakpoint: 1320,
        settings: {
            arrows: false,
            slidesToShow: 4,
            slidesToScroll: 1
        }
    }, 
    {
      breakpoint: 993,
      settings: {
          slidesToShow: 3,
          slidesToScroll: 1
      }
    }, 
    {
      breakpoint: 601,
      settings: {
          slidesToShow: 2,
          slidesToScroll: 1
      }
    }]
});

jQuery('.mobile-slide-view .big_slide').slick({
    dots: true,
    arrows: false,
    infinite: true,
    slidesToShow: 1,
    autoplay: false,
    speed: 1000,
    autoplaySpeed: 3000,
    slidesToScroll: 1,
    responsive: [{
        breakpoint: 993,
        settings: {
            dots: true,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1
        }
    }, 
    {
      breakpoint: 768,
      settings: {
          dots: true,
          autoplay: false,
          slidesToShow: 1,
          slidesToScroll: 1
      }
    }, 
    {
      breakpoint: 601,
      settings: {
          dots: true,
          autoplay: false,
          slidesToShow: 1,
          slidesToScroll: 1
      }
    }, 
    {
      breakpoint: 481,
      settings: {
          dots: true,
          autoplay: false,
          slidesToShow: 1,
          slidesToScroll: 1
      }
    }]
}); 

jQuery("form.product-form").each(function () {
    jQuery(this).bind("submit", function (e) {
      e.preventDefault();
      var formID = jQuery(this).attr("id");
      var formData = jQuery(this).serialize();

      // Validate variant ID is present
      if (!formData.includes('id=')) {
        alert('Please select a variant.');
        return false;
      }

      jQuery.ajax({
        type: 'post',
        url: '/cart/add.js',
        data: formData,
        dataType: 'json',
        success: function (resp) {
          Shopify.KT_getCart();
          KT.drawOpen();
          // console.log(success);
        },
        error: function (error) {
          alert('Error adding to cart. Please try again.');
          // console.log(error)
        }
      });
      return false;
    });
});

jQuery(window).on("scroll", function() {
        if(jQuery(window).scrollTop() > 900) {
            jQuery(".fixed-back-scroll").addClass("fix_top");
        } else {
        //remove the background property so it comes transparent again (defined in your css)
        jQuery(".fixed-back-scroll").removeClass("fix_top");
    }
});  

jQuery(window).on("scroll", function() {
    if (jQuery(window).scrollTop() > 800) {
        jQuery("body").addClass("black-btn-removed").removeClass("visible-black-btn");
    } else {
        jQuery("body").addClass("visible-black-btn").removeClass("black-btn-removed");
    }
});  

jQuery(document).ready(function() {
    if (window.location.href === "https://ishaya.fr/collections/all") {
        jQuery(".template-collection.produits.is-cover .nws-collection.same-section-padd").css("padding-bottom", "0");
    }
});

jQuery('.nws-pdp-template .social-shares .clk-btn').on('click', function(){
  jQuery('.nws-pdp-template .social_sharing_wrapper').toggleClass('active');
});

  jQuery(window).on("scroll", function() {
        if(jQuery(window).scrollTop() > 160) {
            jQuery(".desktop-menu").addClass("fix_top");
        } else {
        //remove the background property so it comes transparent again (defined in your css)
        jQuery(".desktop-menu").removeClass("fix_top");
    }
});


$(document).ready(function() {
  // Handle click on out-of-stock variants
  $('.size-variant.sold-out, .color-variant.sold-out').on('click', function() {
    // Show the notification box
    $('.notification-box').show();
  });

  // Handle click on any available variant
  $('.size-variant:not(.sold-out), .color-variant:not(.sold-out)').on('click', function() {
    // Hide the notification box
    $('.notification-box').hide();
  });
});

$(document).ready(function(){
  $(".nws-product-grid .nws-product-colors .nws-opt").click(function() {
    var cl = $(this).attr("data-call");
    var pr = $(this).attr("data-pr");
    $(".nws-product-grid[data-pr='"+pr+"'] .nws-product-colors .nws-opt").removeClass("active-opt");
    $(this).addClass("active-opt");
    $(".nws-product-grid[data-pr='"+pr+"'] .nws-product-options .nws-opt").hide();
    $(".nws-product-grid[data-pr='"+pr+"'] .nws-product-options .nws-opt[data-call='"+cl+"']").show();
  });
  $(".nws-product-grid .nws-btn-plus").click(function() {
    var pr = $(this).attr("data-pr");
    $(".nws-product-grid[data-pr='"+pr+"']").toggleClass("nws-btn-plus-ac");
  });
});

function addItemToCart(variant_id, qty) {
  data = {
    "id": variant_id,
    "quantity": qty
  }
  jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() {
        Shopify.KT_getCart();
        KT.drawOpen();
    }
  });
}


jQuery(".nws-pdp-template-gallery .nws-pdp-slide-main .nws-pdp-slide").click(function(){
  var x = jQuery(this).attr("data-img-id");
  jQuery('.nws-pdp-template-gallery .nws-pdp-template-oneImagePhoto .nws-pdp-slide-main').removeClass("nws-img-top");
  jQuery('.nws-pdp-template-gallery .nws-pdp-template-oneImagePhoto .nws-pdp-slide[data-img-id="'+x+'"]').parent().addClass("nws-img-top");
});

// jQuery('#shopify-section-template--23409635262794__md_product_section_show_HpC933 .product-list-grid').slick({
//     dots: false,
//     arrows: true,
//     infinite: true,
//     slidesToShow: 4,
//     autoplay: false,
//     speed: 1000,
//     autoplaySpeed: 3000,
//     slidesToScroll: 1,

//     responsive: [{
//         breakpoint: 993,
//         settings: {
//             slidesToShow: 4,
//             arrows: true,
//             dots: false,
//             infinite: true,
//             slidesToShow: 1,
//             slidesToScroll: 1
//         }
//     }, 

//     {
//       breakpoint: 768,
//       settings: {
//           arrows: true,
//           dots: false,
//           autoplay: false,
//           slidesToShow: 1,
//           slidesToScroll: 1
//       }
//     }, 

//     {
//       breakpoint: 601,
//       settings: {
//           arrows: true,
//           dots: false,
//           autoplay: false,
//           slidesToShow: 2,
//           slidesToScroll: 1
//       }
//     }, 

//     {
//       breakpoint: 481,
//       settings: {
//           arrows: true,
//           dots: false,
//           autoplay: false,
//           slidesToShow: 2,
//           slidesToScroll: 1
//       }
//     }]
// }); 
